import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import useSocket from '../../hooks/useSocket';
import './styles.scss';

type DynamicGameUIProps = {
  controlActive: boolean;
  deviceId: string;
  isDeviceConnected: boolean;
};

type v3Command = {
  tag: string;
}

type control = {
  disabled: boolean;
  title: string;
  color?: string;
  command: v3Command | string;
};

const DynamicGameUI = forwardRef(({ controlActive, deviceId, isDeviceConnected }: DynamicGameUIProps, ref) => {
  const [controls, setControls] = React.useState<control[][]>([]);
  const [hasLoadedUI, setHasLoadedUI] = React.useState(false);
  const [deviceVersion, setDeviceVersion] = useState(null);
  const { isConnected, send, subscribe } = useSocket();

  const requestUI = () => {

      send(JSON.stringify({
        channel: 'command',
        metadata: {
          version: 'v2.0',
          ID: 0
        },
        payload: {
          deviceId: deviceId,
          command: 262154
        }
      }));

      setTimeout(() => {
        const command = {
          globalUIRequest: 'globalUIRequest'
        };

        send(JSON.stringify({
          channel: 'command',
          metadata: {
            version: 'v3.0',
            ID: 0
          },
          payload: {
            deviceId: deviceId,
            command: command
          }
        }));
      }, 100);
  };

  const ControlButtonItem = ({ disabled, title, color, command }: control) => {
    const { send } = useSocket();

    const sendCommand = () => {
      if (deviceVersion === 'v2.0') {
        send(JSON.stringify({
          channel: 'command',
          metadata: {
            version: deviceVersion,
            ID: 0
          },
          payload: {
            deviceId: deviceId,
            command: command
          }
        }))
      }
      else if (deviceVersion === 'v3.0') {
        const composedCommand = {} as any;

        composedCommand[(command as v3Command).tag] = (command as v3Command).tag;

        send(JSON.stringify({
          channel: 'command',
          metadata: {
            version: deviceVersion,
            ID: 0
          },
          payload: {
            deviceId: deviceId,
            command: {
              ...composedCommand
            }
          }
        }))
      }
    };

    return (
      <div className="control-button-wrapper">
        <button className={`${disabled && 'control-button-disabled'}`} disabled={disabled}
                style={{ backgroundColor: color }} onClick={() => sendCommand()}>{title}</button>
      </div>
    );
  }

  const ControlButtonSpacer = () => (
    <div className={'control-button-wrapper'}></div>
  );

  const renderControlButtons = (controls: control[][]) => {
    return controls.map((controlRow, row) =>
      <div className={'control-button-container-row'} key={row}>
        {
          controlRow.map((control, col) => {
            if (control) {
              return <ControlButtonItem
                disabled={controlActive}
                key={row + col + 1}
                title={control.title}
                color={control.color}
                command={deviceVersion === 'v2.0' ? control.command : { tag: (control.command as v3Command).tag }}
              />;
            } else {
              return <ControlButtonSpacer/>;
            }
          })
        }
      </div>
    );
  }

  useEffect(() => {
    if (deviceId && isConnected) {
      const unsubscribe = subscribe(`gameUI-device-${deviceId}-response`, (message) => {
        if (!hasLoadedUI) {
          setHasLoadedUI(true);
        }

        setDeviceVersion(message?.metadata?.version);
        setControls(message?.payload?.UI);
      });

      setTimeout(() => {
        requestUI();
      }, 100)

      return unsubscribe;
    }
  }, [deviceId, isConnected]);

  useEffect(() => {
    if (!isDeviceConnected) {
      setControls([]);
    }
  }, [isDeviceConnected]);

  useImperativeHandle(ref, () => ({
    requestUI,
  }));

  return (
    <div className="dynamic-ui-controller">
      {
        controls.length > 0 ?
          renderControlButtons(controls) :
          <p>Waiting for controls from game...</p>
      }
    </div>
  )
});


export default React.memo(DynamicGameUI);
